import { DropdownContext } from 'components/UI/V3/Dropdown/DropdownContext';
import React, { useRef, useState } from 'react';

interface DropdownProps {
    children: React.ReactNode;
    /** Controls the open state of the dropdown when controlled */
    open?: boolean;
    /** Callback fired when the open state changes */
    onOpenChange?: (value: boolean) => void; // eslint-disable-line @typescript-eslint/no-unused-vars
    /** The initial open state when uncontrolled */
    defaultOpen?: boolean;
}

export const Dropdown: React.FC<DropdownProps> = ({
    children,
    open: controlledOpen,
    onOpenChange,
    defaultOpen = false
}) => {
    const [internalOpen, setInternalOpen] = useState(defaultOpen);
    const triggerRef = useRef<HTMLElement>(null);

    const isControlled = controlledOpen !== undefined;
    const open = isControlled ? controlledOpen : internalOpen;

    const setOpen = (newOpen: boolean) => {
        if (!isControlled) {
            setInternalOpen(newOpen);
        }
        onOpenChange?.(newOpen);
    };

    return <DropdownContext.Provider value={{ open, setOpen, triggerRef }}>{children}</DropdownContext.Provider>;
};
